// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Cir,
} from './';

export default {
  path: 'cir',
  name: 'Cir',
  childRoutes: [
    { path: 'cir', name: 'Cir', component: Cir, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/cir/route.js